module.exports = __webpack_public_path__ + "DINNextLTPro-LightItalic.ttf?ef71a9ab670b1f2667c838a6997a46f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-LightItalic.ttf
// module id = 1432
// module chunks = 0